import { createRestApi } from 'civic-champs-shared/api/createRestApi'

import { getAuthorizationToken } from './getAuthorizationToken'

/** Drop-in replacement for Amplify v4 `API` used by admin and shared helpers. */
export const API = createRestApi({
  getAuthorizationToken,
  authorization: 'always',
})
